<header class="z-header" *ngIf="tipo" [ngClass]="{ simple: tipo == 'simple' }">
  <div class="z-wrapper">
    <a class="logotipo" [routerLink]="'/datos-generales'">
      <figure>
        <img src="/assets/img/svg/logoZenit.svg" alt="Logo de Zenit Seguros" width="156px" height="40px" />
      </figure>
    </a>
  </div>
</header>
<div class="z-header-span"></div>